<template>
  <div id="content-container">
    <div class="panel">
      <el-tabs v-model="activeName">
        <el-tab-pane label="使用记录汇总" name="used_data"></el-tab-pane>
        <el-tab-pane
          label="使用记录缺失汇总"
          name="need_used_data"
        ></el-tab-pane>
        <el-tab-pane label="维修记录汇总" name="repair_data"></el-tab-pane>
        <el-tab-pane label="钻井使用统计" name="well_used_data"></el-tab-pane>
        <el-tab-pane label="未使用物资统计" name="not_used_data"></el-tab-pane>
        <el-tab-pane
          label="使用时长阶段统计"
          name="hour_step_data"
        ></el-tab-pane>
      </el-tabs>
      <UsedStatistics
        :category="category"
        v-if="activeName == 'used_data'"
      ></UsedStatistics>
      <NeedUsedStatistics
        :category="category"
        v-if="activeName == 'need_used_data'"
      ></NeedUsedStatistics>
      <RepairStatistics
        :category="category"
        v-if="activeName == 'repair_data'"
      ></RepairStatistics>
      <WellUsedStatistics
        :category="category"
        v-if="activeName == 'well_used_data'"
      ></WellUsedStatistics>
      <NotUsedStatistics
        :category="category"
        v-else-if="activeName == 'not_used_data'"
      ></NotUsedStatistics>
      <HourStepStatistics
        :category="category"
        v-if="activeName == 'hour_step_data'"
      ></HourStepStatistics>
    </div>
  </div>
</template>

<script>
import UsedStatistics from './used_data/index.vue'
import RepairStatistics from './repair_data/index.vue'
import WellUsedStatistics from './well_used_data/index.vue'
import NotUsedStatistics from './not_used_data/index.vue'
import HourStepStatistics from './used_hour_step/index.vue'
import NeedUsedStatistics from './need_used_data/index.vue'

export default {
  components: {
    UsedStatistics,
    RepairStatistics,
    WellUsedStatistics,
    NotUsedStatistics,
    HourStepStatistics,
    NeedUsedStatistics,
  },
  data() {
    return {
      category: 2,
      activeName: '',
    }
  },

  created() {
    if (this.$route.query.filter) {
      const filter = JSON.parse(this.$route.query.filter)
      this.activeName = filter.tab || 'used_data'
    } else {
      this.activeName = 'used_data'
    }
  },
}
</script>